import React from "react"

const CollapsibleHeader = ({ title }) => (
  <div className="collapsible__header">
    <span role="heading" aria-level="2">
      {title}
    </span>
    <div className="plus">
      <div className="line line-1"></div>
      <div className="line line-2"></div>
    </div>
  </div>
)

export default CollapsibleHeader
